import { api } from "../lib/api";

export const clubApi = {
    // Dashboard
    dashboard: () => api.get("/samir/dashboard").then((r) => r.data),

    // Members
    listMembers: (params = {}) => api.get("/samir/members", { params }).then((r) => r.data),
    getMember: (id) => api.get(`/samir/members/${id}`).then((r) => r.data),
    createMember: (data) => api.post("/samir/members", data).then((r) => r.data),
    parseVoiceMember: (transcript, language = "it-IT") =>
        api.post("/samir/members/parse-voice", { transcript, language }).then((r) => r.data),
    parseVoiceMemberAudio: (blob) => {
        const type = (blob.type || "audio/webm").split(";")[0];
        const ext = { "audio/webm": "webm", "audio/mp4": "m4a", "audio/ogg": "ogg", "audio/wav": "wav" }[type] || "bin";
        const fd = new FormData();
        fd.append("audio", blob, `voice.${ext}`);
        return api.post("/samir/members/parse-voice-audio", fd, { timeout: 60000 }).then((r) => r.data);
    },
    updateMember: (id, data) => api.patch(`/samir/members/${id}`, data).then((r) => r.data),
    deleteMember: (id) => api.delete(`/samir/members/${id}`).then((r) => r.data),
    renewMember: (id, data) => api.post(`/samir/members/${id}/renew`, data).then((r) => r.data),

    // Sales
    listSales: (limit = 200) => api.get(`/samir/sales?limit=${limit}`).then((r) => r.data),
    registerSale: (data) => api.post("/samir/sales", data).then((r) => r.data),
    deleteSale: (id) => api.delete(`/samir/sales/${id}`).then((r) => r.data),

    // Payments
    listPayments: () => api.get("/samir/payments").then((r) => r.data),

    // Backup
    exportBackup: () => api.get("/samir/backup").then((r) => r.data),
    restoreBackup: (payload) => api.post("/samir/backup/restore", payload).then((r) => r.data),
};

export const MEMBERSHIP_FEE = 4.90;

export function fmtEur(n) {
    return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));
}

export function fmtDate(s) {
    if (!s) return "-";
    const d = new Date(s);
    if (isNaN(d)) return s;
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
}

export function statusLabel(status) {
    return {
        active: { label: "Attivo", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
        expiring: { label: "In scadenza", cls: "bg-amber-100 text-amber-800 border-amber-200" },
        expired: { label: "Scaduto", cls: "bg-red-100 text-red-700 border-red-200" },
    }[status] || { label: status, cls: "bg-stone-100 text-stone-600 border-stone-200" };
}

export const clubName = (shop) => {
    const n = (shop?.ragione_sociale || "").trim();
    return n && n !== "Il mio negozio" ? `${n} Club` : "Club Soci";
};
